/**
 * Unfinished flow stores the owner already declined to resume in this visit
 * (plan §4.12). Module-scoped on purpose: «Crear una tienda nueva» on
 * `/dashboard` leads to `/new`, which must not ask the same question again,
 * and a page reload (a new visit) asks it once more.
 */
const dismissed = new Set<number>();

export function dismissSetupResume(restaurantId: number): void {
  dismissed.add(restaurantId);
}

export function isSetupResumeDismissed(restaurantId: number): boolean {
  return dismissed.has(restaurantId);
}
